export default __webpack_public_path__ + "static/media/front-end.9e2517dc.png";